import { BasicAsyncEnumerable } from "../async/BasicAsyncEnumerable.js";
import { BasicParallelEnumerable } from "../parallel/BasicParallelEnumerable.js";
import { BasicEnumerable } from "../sync/BasicEnumerable.js";
import { bindArray } from "./bindArray.js";
import { bindArrayEnumerable } from "./bindArrayEnumerable.js";
import { bindLinq } from "./bindLinq.js";
import { bindLinqAsync } from "./bindLinqAsync.js";
import { bindLinqParallel } from "./bindLinqParallel.js";
import { bindString } from "./bindString.js";
bindLinq(BasicEnumerable);
bindLinqAsync(BasicAsyncEnumerable);
bindLinqParallel(BasicParallelEnumerable);
bindArrayEnumerable();
export { bindLinq, bindLinqAsync, bindArray, bindString };
export { initializeLinq } from "./initializeLinq.js";
